export class holidayUpdateRequest {
    holidayId?:number;
    holidayDate:string;
    holidayName:string;
    createdUser:number | null;
    updatedUser: number | null;
    versionFlag: number;
  }
  export class holidayIdRequest {
    holidayId:string;
    updatedUser: number | null;
    versionFlag: number;
  }
  export class holidayStatusUpdateRequest{
    HolidayName:string;
    status:boolean;
  }